import {types} from 'mobx-state-tree';
import * as consts from '../../consts';

export type PaginationModelViews = {
  hasPrevious: boolean;
  hasNext: boolean;
  previousOffset: number;
  nextOffset: number;
  hasCached: boolean;
};

export type PaginationModelActions = {
  page: (offset: number) => void;
};

const PaginationModel = types
  .model('Pagination', {
    limit: types.optional(types.number, consts.PAGINATION__DEFAULT_PER_PAGE),
    total: types.optional(types.number, 0),
    offset: types.optional(types.number, 0),
    cachedOffsets: types.array(types.number)
  })
  .views<PaginationModelViews>(self => {
    // tslint:disable-next-line:no-any
    const computed = (self as any) as PaginationModelViews;

    return {
      get hasPrevious() {
        return self.offset !== 0;
      },
      get hasNext() {
        return computed.nextOffset < self.total;
      },
      get previousOffset() {
        return self.offset - self.limit;
      },
      get nextOffset() {
        return self.offset + self.limit;
      },
      get hasCached() {
        const {cachedOffsets, offset} = self;
        return cachedOffsets.indexOf(offset) > -1;
      }
    };
  })
  .actions(self => {
    return {
      page: function(offset: number) {
        self.offset = offset;
      },
      addOffsetToCache: function(offset: number) {
        self.cachedOffsets.push(offset);
      },
      reset: function() {
        self.offset = 0;
        self.cachedOffsets.clear();
      }
    };
  });

export type PaginationModelType = typeof PaginationModel.Type;

export default PaginationModel;



// WEBPACK FOOTER //
// ./src/models/PaginationModel/PaginationModel.ts